import { render, staticRenderFns } from "./linkdetail.vue?vue&type=template&id=4605a520&scoped=true&"
import script from "./linkdetail.vue?vue&type=script&lang=js&"
export * from "./linkdetail.vue?vue&type=script&lang=js&"
import style0 from "./linkdetail.vue?vue&type=style&index=0&id=4605a520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605a520",
  null
  
)

export default component.exports